import { ready } from 'ext/utils'
import LibSlicksReviewSlider from "global/lib/slicks/review_slider"

ready(() => new LibSlicksReviewSlider)
